import TimelineAnnotationSchema from 'schemas/TimelineAnnotationSchema'

export default function TimelineAnnotationVo(initData = {}) {
  return TimelineAnnotationSchema.validateSync(initData)
}
